// Centralized site data (brand, images, services, gallery)
export const BRAND = {
  name: "MORGAN CONSTRUCTION GROUP",
  legalName: "Morgan Construction Group LLC",
  phoneDisplay: "503-766-8003",
  phoneLink: "tel:+15037668003",
  email: "info@morganconstructiongroup.com",
  emailLink: "mailto:info@morganconstructiongroup.com",
  serviceArea: "Oregon & Washington",
  yearsInBusiness: 10,
  ccbLicense: "230879",
  tagline: "Custom remodeling & renovation, built to last.",
};

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1649083048391-1c9e82472f65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvcGVuJTIwa2l0Y2hlbiUyMGRlc2lnbnxlbnwwfHx8fDE3NzY2NTM2MzN8MA&ixlib=rb-4.1.0&q=85",
  kitchen:
    "https://images.unsplash.com/photo-1563493461953-aeee5e293b66?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvcGVuJTIwa2l0Y2hlbiUyMGRlc2lnbnxlbnwwfHx8fDE3NzY2NTM2MzN8MA&ixlib=rb-4.1.0&q=85",
  bathroom:
    "https://images.unsplash.com/photo-1760546120487-ccb54df9838c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBiYXRocm9vbSUyMHNob3dlcnxlbnwwfHx8fDE3NzY2NTM2MzJ8MA&ixlib=rb-4.1.0&q=85",
  living:
    "https://images.unsplash.com/photo-1759722667709-648009e31c25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tJTIwdGlsZSUyMGZsb29yfGVufDB8fHx8MTc3NjY1MzYzMnww&ixlib=rb-4.1.0&q=85",
  gallery1:
    "https://images.unsplash.com/photo-1771681587476-f2846a2c9102?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBiYXRocm9vbSUyMHNob3dlcnxlbnwwfHx8fDE3NzY2NTM2MzJ8MA&ixlib=rb-4.1.0&q=85",
  gallery2:
    "https://images.unsplash.com/photo-1758448018619-4cbe2250b9ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsdXh1cnklMjBiYXRocm9vbSUyMHNob3dlcnxlbnwwfHx8fDE3NzY2NTM2MzJ8MA&ixlib=rb-4.1.0&q=85",
  gallery3:
    "https://images.unsplash.com/photo-1770751188011-8ab6c81552bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tJTIwdGlsZSUyMGZsb29yfGVufDB8fHx8MTc3NjY1MzYzMnww&ixlib=rb-4.1.0&q=85",
  modernWhiteHome:
    "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const SERVICES = [
  {
    slug: "kitchens",
    title: "Kitchen Remodeling",
    summary:
      "Open-plan layouts, large-format tile, custom cabinetry and stone surfaces built for everyday living.",
    image: IMAGES.kitchen,
    features: [
      "Custom cabinetry & islands",
      "Quartz, marble & stone surfaces",
      "Large-format porcelain tile",
      "Lighting & electrical upgrades",
    ],
  },
  {
    slug: "bathrooms",
    title: "Bathroom Remodeling",
    summary:
      "Modern walk-in showers, freestanding tubs and luxurious tile work that turn bathrooms into retreats.",
    image: IMAGES.bathroom,
    features: [
      "Curbless & walk-in showers",
      "Freestanding tub installation",
      "Heated tile flooring",
      "Custom vanities & lighting",
    ],
  },
  {
    slug: "living-rooms",
    title: "Living Rooms & Flooring",
    summary:
      "Large-format tile, hardwood and feature walls that open up living spaces with modern warmth.",
    image: IMAGES.living,
    features: [
      "Large-format tile flooring",
      "Hardwood refinishing & install",
      "Feature walls & built-ins",
      "Fireplace surrounds",
    ],
  },
  {
    slug: "full-remodel",
    title: "Full-Home Renovation",
    summary:
      "Whole-home renovations managed end-to-end — from demolition and framing to final finishes.",
    image: IMAGES.hero,
    features: [
      "Permitting & project management",
      "Framing, drywall & finishing",
      "Integrated design consultation",
      "Licensed, bonded & insured",
    ],
  },
];

export const GALLERY = [
  { id: 1, src: IMAGES.kitchen, category: "Kitchens", title: "Open Kitchen · Portland, OR" },
  { id: 2, src: IMAGES.bathroom, category: "Bathrooms", title: "Spa Bathroom · Beaverton, OR" },
  { id: 3, src: IMAGES.living, category: "Living Rooms", title: "Tile Flooring · Vancouver, WA" },
  { id: 4, src: IMAGES.gallery1, category: "Bathrooms", title: "Brass Shower · Lake Oswego, OR" },
  { id: 5, src: IMAGES.gallery2, category: "Bathrooms", title: "Marble Vanity · Seattle, WA" },
  { id: 6, src: IMAGES.gallery3, category: "Living Rooms", title: "Kitchen-Living Open Plan · Bellevue, WA" },
  { id: 7, src: IMAGES.hero, category: "Kitchens", title: "Island Kitchen · Hillsboro, OR" },
];
